import React, {createElement, useEffect, useState} from 'react'
import { TYPE_Chip, useChip } from "@ifeng/lowcode_tool/src/hooks/useChip";
import axios from 'axios'
import { jsonp } from '@ifeng/ui_base'
import Style from './index.module.scss'

export interface Survey_1_props {
    nodeId?: string
    style?: object
    surveyChip: TYPE_Chip
    itemWidth: number;
    imageHeight: number;

    // 图片设置
    imageObjectFit: any;
    imageStyle?: object

    // 标题设置
    titleStyle?: object

    // 描述设置
    isShowSummary: boolean
    summaryStyle?: object

    // 投票数
    isShowVoteNum: boolean
    voteNumStyle?: object

    // 投票按钮
    voteBtnText: string // 投票文本
    voteBtnPosition: 'flex-start' | 'center' | 'flex-end' // 文本位置
    voteSuccessText: string // 投票成功后的通知文本
    voteBtnStyle?: object
}

const Survey_1: React.FC<Survey_1_props> = (props) => {
    const { nodeId, style, surveyChip, itemWidth, imageHeight,
        imageStyle, imageObjectFit,
        titleStyle,
        isShowSummary, summaryStyle,
        isShowVoteNum, voteNumStyle,
        voteBtnText, voteBtnStyle, voteSuccessText, voteBtnPosition
    } = props

    const [ surveyDetail, setSurveyDetail ] = useState([]) // 从投票接口拿过来的投票信息
    const surveyChipData = useChip(surveyChip)

    const fetchSurveyDetail = async () => {
        const surveyIds = surveyChipData.map(s => s.survey_id)
        const surveyDetailRes = await axios.get(`http://sv.ifeng.com/index.php/survey/getdata?id=${surveyIds.join(',')}`)

        if (surveyDetailRes.data.ifsuccess === 1) {
            setSurveyDetail(surveyDetailRes.data.data.length > 1 ? surveyDetailRes.data.data : [surveyDetailRes.data.data])
        }
    }

    useEffect(() => {
        fetchSurveyDetail()
    }, [surveyChipData])

    const toVote = async (surveyInfo) => {
        try {
            const res = await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?sur[${surveyInfo.result[0]?.resultArray.questionid}][]=${surveyInfo.result[0]?.resultArray.option[0].itemid}`, {
                data: { id: surveyInfo.surveyinfo.id },
                jsonpCallback: 'callback',
                cache: false,
            });

            if (res && res.ifsuccess) {
                alert(voteSuccessText)
                fetchSurveyDetail()
            } else {
                alert(res.msg || '点赞失败');
            }
        } catch (error) {
            alert(error.message);
        }
    }


    // http://sv.ifeng.com/index.php/survey/getdata?id=6976105441579241472,6960438371931922432

    return (
        <div id={nodeId} className={Style.survey_1} style={style}>
            {
                surveyDetail.length > 0
                    ?
                        <div className={Style.surveyList}>
                            {
                                surveyDetail.map((survey, index) => {
                                    return (
                                        <div className={Style.surveyItem} key={index} style={{ width: `${itemWidth}px` }}>
                                            <div className={Style.imagePart}>
                                                <img style={{ width: `${itemWidth}px`, height: `${imageHeight}px`, objectFit: imageObjectFit, ...imageStyle }} src={surveyChipData.find(s => s.survey_id === survey.surveyinfo.id)?.image} alt="" />
                                            </div>
                                            <div className={Style.textPart}>
                                                <div className={Style.title} style={titleStyle}>{survey.surveyinfo.title}</div>
                                                {
                                                    isShowSummary &&
                                                    <div className={Style.desc} style={summaryStyle}>
                                                        {survey.surveyinfo.leadtxt}
                                                    </div>
                                                }
                                            </div>
                                            {
                                                isShowVoteNum &&
                                                <div style={voteNumStyle}>
                                                    {survey.result[0]?.resultArray.option[0].num} 票
                                                </div>
                                            }
                                            <div style={{ display: 'flex', justifyContent: voteBtnPosition }}>
                                                <div onClick={() => toVote(survey)} style={voteBtnStyle}>{voteBtnText}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    : '暂无投票'
            }
        </div>
    )
}

export default Survey_1
